import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CatDataType, WeeklyService } from "../services/weekly.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Storage } from "@ionic/storage";
import { Router } from "@angular/router";
import { IonContent, ToastController } from "@ionic/angular";
import { Events } from "@ionic/angular";
import { LoadingController } from "@ionic/angular";
import { MenuController } from "@ionic/angular";
import { BarcodeScanner } from "@ionic-native/barcode-scanner/ngx";
import { AlertController } from "@ionic/angular";
import { IonSlides } from "@ionic/angular";
import { S3imagesService } from '../services/s3images.service';

//  const condition = true;
@Component({
  selector: "app-category",
  templateUrl: "./category.page.html",
  // styleUrls: condition ? ['./category.page.scss'] :  ['./desktop_category.page.scss'],
  styleUrls: ["./category.page.scss"],
})
export class CategoryPage implements OnInit {
  newUrl = this.images3Service.s3url;
  category: any; // Observable<any>;
  selectcity = [];
  selectedGroupcode:any;
  StockwithImg:any;
  SlideDidChange:any;
  sliderThree:any;
  catelist: CatDataType[] = [];
  card: any = [];
item:any;
  @ViewChild(IonContent, {}) content: IonContent;
  header: string;
  cardno: string;
  password: string;
  loaderToShow: any;
  searchPlaceHolder: String = "What are you looking for ?";
  toast: any;
  cartcount: any;
  BannerImg: any;
  bannerImg_res: any;
  currency: string;
  isGuest: string;
  finalarray: any[];
    constructor(
    public menu: MenuController,
    private activatedRoute: ActivatedRoute,
    private route: ActivatedRoute,
    private movieService: WeeklyService,
    public toastController: ToastController,
    public http: HttpClient,
    public storage: Storage,
    private router: Router,
    public events: Events,
    public loadingController: LoadingController,
    private alertController: AlertController,
    private barcodeScanner: BarcodeScanner,
    private images3Service :S3imagesService
  ) {
    this.currency = this.movieService.getCurrency();
    this.isGuest = this.movieService.getIsGuest();

    this.getcatlist();

    this.callApi();
  }
  
  @ViewChild("mySlider") slides: IonSlides;
  slideOpts = {
    slidesPerView: 3,
    grabCursor: true,
    autoplay: {
      delay: 3000, // Auto-play delay in milliseconds
      disableOnInteraction: false, // Continue auto-play after user interaction
    },
  }

  swipeNext() {
    this.slides.slideNext();
  }

  swipePrev() {
    this.slides.slidePrev();
  }

  ngOnInit() {
    this.selectedGroupcode = this.route.snapshot.paramMap.get("selectedGroupcode")
    console.log("dadtadta",this.selectedGroupcode)
    this.getGroupDynamic();
    // this.callApi();
  }
  ionViewWillEnter() {
    this.callApi();
  }

  getGroupDynamic() {
    let subproductt: any;
    let ddata = [];
    let newArrayyimg = [];
    let newArrayy = [];
    let combined = [];
    this.category = this.movieService.getGroupCategoryDynamic("Groc");
    this.category.subscribe(async data => {
      subproductt = data.value;
      for (let datam of subproductt) {
        console.log("subproductt",subproductt)
        let Code = datam.Code;
        newArrayy.push({
          Code: datam.Code,
          Description: datam.Description,
          Image: this.movieService.imageUrl+ datam.Code+this.movieService.imageFormat
        })
      }
      this.finalarray = newArrayy;
      console.log("this.finalarray",this.finalarray)

    });

  }
 

  getcatlist() {
    this.header = this.movieService.getStorageHeader();
    this.cardno = this.movieService.getStorageCardNo();
    this.password = this.movieService.getStoragePassword();
    this.movieService
      .getCatDataWithObservable(this.cardno, this.header, this.password)
      .subscribe((res) => {
        this.catelist = res;
        console.log(
          "getUsersWithSubscription" + JSON.stringify(this.catelist)
        );
      });
  }

  callApi() {
    this.menu.enable(false);
    //  this.showLoader();
    this.callSecondPageImage();
    this.cartcount = this.movieService.getCardCount();
  }

  callSecondPageImage() {
    // this.showLoader();
    this.header = this.movieService.getStorageHeader();
    this.cardno = this.movieService.getStorageCardNo();
    this.password = this.movieService.getStoragePassword();
    this.bannerImg_res = this.movieService.getSecondPageImage(
      this.cardno,
      this.header,
      this.password
    );
    this.bannerImg_res.subscribe((data) => {
      if (data.status == "true") {
        this.BannerImg = data.Image;
      }
    });
  }

  cartClick() {
    if (this.cartcount == 0) {
      this.presentAlert("Continue Shopping", "Your Cart is Empty");
    } else {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["cart"]);
      });
    }
  }

  async presentAlert(msg: any, submsg: any) {
    const alert = await this.alertController.create({
      message: msg,
      subHeader: submsg,
      buttons: [
        // {
        //   text: 'Cancel',
        //   handler: data => {
        //     console.log('Cancel clicked');
        //   }
        // },
        {
          text: "ok",
          handler: (data) => {
            // console.log('Saved clicked');
          },
        },
      ],
    });
    await alert.present();
  }

  scannerclick() {
    this.barcodeScanner
      .scan()
      .then((barcodeData) => {
        this.startMySearchThread().then((truthy) => {
          if (barcodeData.text == "" || barcodeData.text == null) {
            this.showToast("Not Properly Scanned");
          } else {
            this.router.navigate(["search", { scannedData: barcodeData.text }]);
          }
        });
      })
      .catch((err) => {
        alert(err);
      });
  }

  showLoader() {
    this.loaderToShow = this.loadingController
      .create({
        message: "Please Wait...",
      })
      .then((res) => {
        res.present();

        res.onDidDismiss().then((dis) => {
          console.log("Loading dismissed!");
        });
      });
    // this.hideLoader();
  }

  hideLoader() {
    setTimeout(() => {
      this.loadingController.dismiss();
    }, 100);
  }

  groupItemClick(groupName) {
    console.log("groupName",groupName)
    this.startMyThread().then((truthy) => {
      this.router.navigate(["subcategory", { selectedGroup: groupName }]);
    });
  }

  startMyThread() {
    return new Promise((resolve, reject) => {
      //pretend a long-running task
      setTimeout(() => {
        resolve(true);
      }, 100);
    });
  }

  ScrollToTop() {
    this.content.scrollToTop(1500);
  }

  searchClick() {
    this.startMySearchThread().then((truthy) => {
      this.router.navigate(["search", { scannedData: "" }]);
    });
  }

  startMySearchThread() {
    return new Promise((resolve, reject) => {
      //pretend a long-running task
      setTimeout(() => {
        resolve(true);
      }, 10);
    });
  }

  showToast(msg) {
    this.toast = this.toastController
      .create({
        message: msg,
        duration: 2000,
      })
      .then((toastData) => {
        toastData.present();
      });
  }

  HideToast() {
    this.toast = this.toastController.dismiss();
  }

  // ----------------------above header click-----------------------------------------
  loginnavigate() {
    this.startMyThread().then((truthy) => {
      this.router.navigate(["login"]);
    });
  }

  redirectCart() {
    if (this.isGuest == "true") {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["cart"]);
      });
    } else if (this.isGuest == "false") {
      this.cartClick();
    }
  }

  orderhistory() {
    if (this.isGuest == "true") {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["login"]);
      });
    } else if (this.isGuest == "false") {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["orderhistory"]);
      });
    }
  }

  // loginnavigate() {

  //   if (this.isGuest == 'true') {
  //     this.startMyThread().then(truthy => {
  //       this.router.navigate(['login']);
  //     });

  //   } else if (this.isGuest == 'false') {

  //   }

  // }

  // orderhistory() {

  //   if (this.isGuest == 'true') {

  //     this.startMyThread().then(truthy => {
  //       this.router.navigate(['orderhistory']);
  //     });

  //   } else if (this.isGuest == 'false') {
  //   }

  // }

  menuItemClick(itemname) {
    if (itemname == "Home") {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["home"]);
      });
    } else if (itemname == "Weekly Deals") {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["weekly-special", { whichWeekly: "" }]);
      });
    } else if (itemname == "Customer Service") {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["customer-services"]);
      });
    } else if (itemname == "Shop by Groceries") {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["category"]);
      });
   
        
      } else if (itemname == "Notification") {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["notification"]);
      });
    } else if (itemname == "Reorder List") {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["wishlist"]);
      });
    } else if (itemname == "Feedback") {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["feedback"]);
      });
    } else if (itemname == "Gift Card") {
      this.startMyThread().then((truthy) => {
        this.router.navigate(["giftcard"]);
      });
    } else if (itemname == "Do It Rewards Card") {
      // this.startMyThread().then(truthy => {
      //   if (this.AccountType == "Credit") {
      //     this.router.navigate(['own-card']);
      //   } else {
      //     this.router.navigate(['card']);
      //   }
      // });
    } else if (itemname == "Logout" || itemname == "Login") {
      // this.storage.set('loginUsername', null);
      // this.storage.set('loginId', null);

      if (itemname == "Login") {
        this.storage.clear();

        this.startMyThread().then((truthy) => {
          this.router.navigate(["login"], { replaceUrl: true });
        });
      } else if (itemname == "Logout") {
        // this.callLogoutApi();
      }
    }
  }
}
